import { IRetentionPolicyResponse } from '../../../../store/api/devices/types';
import { byteToMegaByte } from '../../../../utils/helpers';
import { useRetentionData } from './hooks';
import { retentionFields } from './helpers';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../ui/card';

const RetentionPolicies = () => {
  const { values, isLoading, error } = useRetentionData();

  const renderReadOnlyField = (label: string, value: string, key: string, className = "") => (
    <div className={`flex flex-col gap-1 ${className}`} key={key}>
      <label className="text-sm text-muted-foreground">{label}</label>
      <div className="text-sm font-semibold text-foreground">{value}</div>
    </div>
  );

  if (isLoading) {
    return <p className="text-sm text-muted-foreground p-4">Loading...</p>;
  }

  if (error) {
    return <p className="text-sm text-destructive p-4">Failed to load data.</p>;
  }

  return (
    <div
      className="flex flex-col w-full overflow-y-auto px-3 md:px-3 pt-5 pb-10"
      style={{ color: "var(--foreground)" }}
    >
      <Card>
        <CardHeader className="flex flex-col gap-2 space-y-0 p-3 pl-6 pr-5 pt-3 pb-1">
          <div>
            <CardTitle className="mb-0">Storage Limit Per Device</CardTitle>
            <CardDescription className="mt-1">
              How long or how much data to retain for each category.
            </CardDescription>
          </div>
          <div className="-mx-6 border-t border-border/50" aria-hidden />
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid max-w-3xl grid-cols-1 gap-x-6 gap-y-3 md:grid-cols-2">
            {retentionFields.map(({ label, key, unit }) =>
              renderReadOnlyField(
                label,
                `${byteToMegaByte(values[key as keyof IRetentionPolicyResponse] || 0)} ${unit}`,
                key,
                key === 'COREFILE_MAX_SIZE' || key === 'SN_DB_MAX_SIZE' ? 'md:mt-4' : ''
              )
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RetentionPolicies;
